module.exports = __webpack_public_path__ + "img/Huygenstijdmachine-05.51706c64.svg";